/**
 * Sends a tracking event if analytics is activated.
 * Besides the given information it also adds some basic information like the current page the tracking was executed.
 *
 * Note: Structure/params are defined by marketing wishes:
 * - group either use `formwizard` (default) or `formwizard_additional_steps` for the extended wizard.
 * - label is either the text of element the user clicks on, the keyboard event which proceed the stepper
 *   or "done" in case it submits the data in the end.
 * - step saves the transition between two steps to allow following the path through the dialog.
 *   Start and end have no "variants", so step is not defined in that case.
 * - recruiterId, leadId for campaign tracking (maybe changing in future).
 * - dialogId to track which dialog the user goes through.
 *
 * Note 2: Back-navigation is not tracked as not wished.
 *
 * @param event {string}
 * @param params {object=} - Additional parameter like group, label...
 */
const analyticsTrack = ({ event, params }) => {
  const filteredParams = {
    path: window.location.pathname,
    pathOrigin: window.location.origin,
    group: 'formwizard',
  };

  // Ensure we are not sending values with null or undefined as those are forbidden.
  Object.keys(params).forEach((key) => {
    if (params[key] !== null && params[key] !== undefined) {
      filteredParams[key] = params[key];
    }
  });

  window?.analytics?.track(event, filteredParams);
};

export default analyticsTrack;
